import React, { Component } from 'react';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import { Dialog as DialogPrime } from 'primereact/dialog';
import ResumoCheckList from '../PareceresAreaTecnica/ResumoCheckList';
import { dominioDemandaCirurgica } from '../../config/database';
import 'assets/css/minha-agenda.css';
import 'primeicons/primeicons.css';

class AgendaMedico extends Component {
  state = {
    pedidos: [],
    pedidoSelecionado_id: null,
    filtroMeusPedidos: true,
    botoesMeusPedidos: {},
    botoesCentroCirurgico: {},
    centrosCirurgicos: [],
    centroCirurgicoSelecionado: 0
  };

  limparLocalStoragePedido = () => {
    localStorage.setItem('activeStep', '0');
    localStorage.removeItem('convenio');
    localStorage.removeItem('peso');
    localStorage.removeItem('completed');
    localStorage.removeItem('paciente');
    localStorage.removeItem('dadosSolicitacao');
    localStorage.removeItem('faa');
    localStorage.removeItem('atendimento');
    localStorage.removeItem('data_atendimento');
    localStorage.removeItem('seq_atendimento');
    localStorage.removeItem('carater');
    localStorage.removeItem('profissionalResponsavel');
    localStorage.removeItem('dataSugerida');
    localStorage.removeItem('centroCirurgico');
    localStorage.removeItem('lateralidade');
    localStorage.removeItem('indicacaoClinica');
    localStorage.removeItem('prioridade');
    localStorage.removeItem('cidPrincipal');
    localStorage.removeItem('cidsSecundarios');
    localStorage.removeItem('tipoAcomodacao');
    localStorage.removeItem('diariasPrevistas');
    localStorage.removeItem('leitoUTI');
    localStorage.removeItem('tipoAnestesia');
    localStorage.removeItem('caixasOPME');
    localStorage.removeItem('materiaisConsumiveis');
    localStorage.removeItem('caixasCirurgicas');
    localStorage.removeItem('hemoderivados');
    localStorage.removeItem('procedimentoPrincipal');
    localStorage.removeItem('procedimentosSecundarios');
    localStorage.removeItem('documentos');
    localStorage.removeItem('pedidoCirurgia');
    localStorage.removeItem('equipamentos');
    localStorage.removeItem('duracaoEstimada');
    localStorage.removeItem('email');
    localStorage.removeItem('celular');
    localStorage.removeItem('telefone');
    localStorage.removeItem('exames');
    localStorage.removeItem('dataInternacao');
    localStorage.removeItem('motivoAntecipacaoInternacao');
    localStorage.removeItem('avaliacaoAnestesica');
    localStorage.removeItem('motivoAvaliacaoAnestesica');
    localStorage.removeItem('modalidadeAtendimento');
    localStorage.removeItem('novoPaciente');
    localStorage.removeItem('tipoPedido');
    localStorage.removeItem('centroCirurgicoPermitido');
    localStorage.removeItem('caraterAtendimentoPermitido');
    localStorage.removeItem('lateralidadePermitida');
    localStorage.removeItem('cidPrincipalPermitido');
    localStorage.removeItem('cidSecundarioPermitido');
    localStorage.removeItem('tipoAcomodacaoPermitido');
    localStorage.removeItem('motivoAntecipacaoPermitido');
    localStorage.removeItem('tipoAnestesiaPadrao');
    localStorage.removeItem('procedimentoPrincipalPermitido');
    localStorage.removeItem('procedimentoSecundarioPermitido');
    localStorage.removeItem('caixaOPMEPermitida');
    localStorage.removeItem('materialConsumivelPermitido');
    localStorage.removeItem('caixaCirurgicaPermitida');
    localStorage.removeItem('hemocomponentePermitido');
    localStorage.removeItem('equipamentoPermitido');
    localStorage.removeItem('pedidoCirurgiaVemDoModelo');
    localStorage.removeItem('salaCirurgia');
    localStorage.removeItem('demandaId');
    localStorage.removeItem('listaModalidadeAtendimento');
  };

  componentDidMount() {
    this.limparLocalStoragePedido();
    this.listarPedidosCirugia(this.state.filtroMeusPedidos);
    this.renderCustomButtons();
  }

  componentDidUpdate() {
    const botaoMeusPedidos = document.getElementsByClassName(`fc-botaoMeusPedidos-button`)[0];
    const botaoTodos = document.getElementsByClassName(`fc-botaoTodos-button`)[0];

    if (this.state.filtroMeusPedidos) {
      botaoMeusPedidos.style = null;
      botaoTodos.style.backgroundColor = 'lightgray';
      botaoTodos.style.color = 'black';
    } else {
      botaoTodos.style = null;
      botaoMeusPedidos.style.backgroundColor = 'lightgray';
      botaoMeusPedidos.style.color = 'black';
    }
  }

  renderCustomButtons = () => {
    const buttonsMeusPedidos = {
      botaoMeusPedidos: {
        text: 'Meus Pedidos',
        click: this.handleFiltrarMeusPedidos,
      },
      botaoTodos: {
        text: 'Todos',
        click: this.handleFiltrarTodos,
      },
    };

    this.setState({botoesMeusPedidos: buttonsMeusPedidos});

    const centrosCirurgicosPermitidos = JSON.parse(localStorage.profissional).centrosCirurgicos;
    const botoes = {};

    dominioDemandaCirurgica.get('/api/centroCirurgico').then(response => {
      response.data.forEach(centroCirurgico => {
        if (centrosCirurgicosPermitidos.includes(centroCirurgico.id)) {
          botoes[`centrocirurgico${centroCirurgico.id}`] = {
            text: centroCirurgico.departamento,
            click: () => {
              this.handleClickBotaoCentroCirurgico(centroCirurgico.id);
            },
          };

          this.setState({centrosCirurgicos: [...this.state.centrosCirurgicos, centroCirurgico.id]});
        }
      });

      this.setState({
        botoesCentroCirurgico: botoes,
      });
    });
  };

  handleClickBotaoCentroCirurgico = (IdCentroCirurgico) => {
    const botao = document.getElementsByClassName(`fc-centrocirurgico${IdCentroCirurgico}-button`)[0];

    if (!botao.classList.contains('selecionado')) {
      botao.classList.add('selecionado');

      this.setState({ centroCirurgicoSelecionado: IdCentroCirurgico });

      this.listarPedidosCirugia(this.state.filtroMeusPedidos, IdCentroCirurgico);

      this.state.centrosCirurgicos.forEach(centroCirurgico => {
        let alteraBotao = document.getElementsByClassName(`fc-centrocirurgico${centroCirurgico}-button`)[0];

        if (IdCentroCirurgico !== centroCirurgico)
          alteraBotao.classList.remove('selecionado');
      });
    } else {
      botao.classList.remove('selecionado');

      this.setState({ centroCirurgicoSelecionado: 0 });

      this.listarPedidosCirugia(this.state.filtroMeusPedidos, '0');
    }
  };

  listarPedidosCirugia(filtroMeusPedidos, centroCirurgico = null) {
    const { profissional_id } = JSON.parse(localStorage.getItem('profissional'));

    let url = '';

    if (centroCirurgico) {
      if (filtroMeusPedidos) url = `api/agendaMedico/${profissional_id}/${centroCirurgico}`;
      else url = `api/agendaEquipeMedico/${profissional_id}/${centroCirurgico}`;
    } else {
      if (filtroMeusPedidos) url = `api/agendaMedico/${profissional_id}/${this.state.centroCirurgicoSelecionado}`;
      else url = `api/agendaEquipeMedico/${profissional_id}/${this.state.centroCirurgicoSelecionado}`;
    }

    dominioDemandaCirurgica.get(url).then(response => {
      this.setState({
        pedidos: response.data.map(pedido => {
          return {
            id: pedido.id,
            title: pedido.codigo,
            start: pedido.dataCirurgia,
            cor: pedido.cor,
            corBolinha: pedido.corbolinha,
          };
        }),
      });
    });
  }

  handleEventClick = info => {
    this.setState({
      pedidoSelecionado_id: info.event.id,
    });
  };

  eventContent = arg => {
    //  Divs internas para fazer as divisões
    const divCentral = document.createElement('div');
    const divEsquerda = document.createElement('div');
    const divDireita = document.createElement('div');

    //  Cor do status
    divCentral.style.backgroundColor = arg.event._def.extendedProps.cor;
    divCentral.style.color = 'white';

    //  Atribuindo as classes
    divCentral.classList.add('div-central-evento');
    divEsquerda.classList.add('div-esquerda-evento');
    divDireita.classList.add('div-direita-evento');

    divCentral.appendChild(divEsquerda);
    divCentral.appendChild(divDireita);

    //  codigo
    const codigoPedido = document.createElement('span');
    codigoPedido.innerText = arg.event._def.title;
    divEsquerda.appendChild(codigoPedido);

    //  colocando a bolinha

    if (arg.event._def.extendedProps.corBolinha) {
      const bolinha = document.createElement('span');
      bolinha.classList.add('bolinha');
      bolinha.style.backgroundColor = arg.event._def.extendedProps.corBolinha ?? 'lightgray';
      divDireita.appendChild(bolinha);
    }

    const arrayDeDomNodes = [divCentral];
    return { domNodes: arrayDeDomNodes };
  };

  handleFiltrarMeusPedidos = () => {
    this.setState({
      filtroMeusPedidos: true,
    });
    this.listarPedidosCirugia(true);
  };

  handleFiltrarTodos = () => {
    this.setState({
      filtroMeusPedidos: false,
    });
    this.listarPedidosCirugia(false);
  };

  render() {
    return (
      <div id="naruto">
        <DialogPrime
          visible={this.state.pedidoSelecionado_id}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ pedidoSelecionado_id: null })}
        >
          <ResumoCheckList id={this.state.pedidoSelecionado_id} />
        </DialogPrime>

        <GridContainer justify="center" id="agenda">
          <GridItem xs={12} sm={12} md={11}>
            <FullCalendar
              //  https://fullcalendar.io/docs
              plugins={[dayGridPlugin, timeGridPlugin, listPlugin]}
              initialView="timeGridWeek"
              locale="pt-br"
              navLinks
              editable
              dayMaxEvents
              customButtons={{...this.state.botoesMeusPedidos, ...this.state.botoesCentroCirurgico}}
              buttonText={{
                day: 'Dia',
                month: 'Mês',
                next: '>',
                nextYear: 'Próximo ano',
                prev: '<',
                prevYear: 'Ano anterior',
                today: 'Hoje',
                week: 'Semana',
              }}
              headerToolbar={{
                left: `prev,next,today botaoMeusPedidos,botaoTodos${this.state.botoesCentroCirurgico
                  ? ` ${Object.keys(this.state.botoesCentroCirurgico).join()}`
                  : ''
                }`,
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay',
              }}
              eventDidMount={this.insertDivBotao}
              events={this.state.pedidos}
              eventClick={this.handleEventClick}
              eventContent={this.eventContent}
              moreLinkText="pedidos"
              dragScroll
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}
export default AgendaMedico;
